import React from 'react';
import Lottie from 'lottie-react';
import loader from '../assets/loading-rings.json';

const LoadingElement = ({ display }) => {
  return (
    <div id="loader" className={`fixed inset-0 flex items-center justify-center ${display}`}>
      <div className="loader-background absolute inset-0"></div>
      <Lottie
        animationData={loader}
        loop={true}
        autoplay={true}
        style={{ width: 100, maxWidth: 100, zIndex: 10 }}
      />
    </div>
  );
};

export default LoadingElement;
